import { useMemo } from 'react';

import { ENABLED_LANGUAGES, MENU_ITEMS } from '../constants';
import { MenuItem, OrderableMenuItem } from '../types';

const EXTRA_MENU_ITEMS: MenuItem[] = ['loyalty', 'hc'];

const useMenuItems = ({
  enabledMenuItems,
  hiddenMenuItems,
  lang,
}: {
  enabledMenuItems?: MenuItem[];
  hiddenMenuItems?: MenuItem[];
  lang: string;
}) => {
  return useMemo(() => {
    const getAllMenuItems = (): OrderableMenuItem[] => {
      if (!ENABLED_LANGUAGES.includes(lang)) {
        return MENU_ITEMS.filter((item) => item.default);
      }

      return MENU_ITEMS.filter((item) => item.allowedLanguages.includes(lang));
    };

    const getAvailableMenuItems = (): OrderableMenuItem[] => {
      const sortedMenuItems = getAllMenuItems().sort((a, b) => a.mobileOrder - b.mobileOrder);

      if (enabledMenuItems) {
        return sortedMenuItems.filter((item) => enabledMenuItems.includes(item.productKey));
      }

      return sortedMenuItems.filter((item) => !(hiddenMenuItems || []).includes(item.productKey));
    };

    const availableMenuOrderableItems = getAvailableMenuItems();
    const mainMenuOrderableItems: OrderableMenuItem[] = [];
    const extraMenuItems: MenuItem[] = [];

    availableMenuOrderableItems.forEach((item) => {
      if (EXTRA_MENU_ITEMS.includes(item.productKey)) {
        extraMenuItems.push(item.productKey);
      } else {
        mainMenuOrderableItems.push(item);
      }
    });

    const mainMenuItems: MenuItem[] = mainMenuOrderableItems
      .sort((a, b) => a.desktopOrder - b.desktopOrder)
      .map((item) => item.productKey);
    const availableMenuItems: MenuItem[] = availableMenuOrderableItems.map(
      (item) => item.productKey
    );

    return { availableMenuItems, mainMenuItems, extraMenuItems };
  }, [enabledMenuItems, hiddenMenuItems, lang]);
};

export default useMenuItems;
